import axios from "axios";
import Config from "../utils/Config";


class RestService {

  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }

  async login(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/Login",
      formData,
    )
    return data;
  }

  async companyRegistration(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + "/api/company/",
      formData
    )
    return data.data;
  }

  async companyAdminRegistration(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/register/",
      formData
    )
    return data.data;
  }

  async forgetPwd(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/forgetPwd/",
      formData
    )
    return data.data;
  }

  async resetPwd(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + `/api/auth/resetPwd/`,
      formData
    )
    return data.data;
  }

  async initialPassChange(formData, id) {
    const data = await axios.post(
      Config.BACKEND_URL + `/api/auth/initialPassChange/${id}`, //api/auth/initialPassChange/{id}
      formData
    )
    return data.data;
  }

  async passwordChangeFromLogin(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/changePassword",
      formData,
      this.config
    );
    return data.data;
  }

  async resendAccVerification(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/resendAccVerification/", //api/auth/resendAccVerification
      formData
    )
    return data.data;
  }

  async activeCompanyAdmin(formData) {
    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/activeCompanyAdminAcc/", ///api/auth/activeCompanyAdminAcc/672c36bc6572931366f9d522
      formData
    )
    return data.data;
  }

  async testWithJWTandCID(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    console.log(this.config)

  }

  //get two factor status
  async getTwoFactorStatus(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const data = await axios.get(
      Config.BACKEND_URL + `/api/auth/2fa/options`, ///api/auth/2fa/options
      this.config
    )
    return data.data;
  }

  async requestOtpforTwoFactor(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/2fa/request", ///api/auth/2fa/request
      formData,
      this.config
    );
    return data.data;
  }

  async verifyOtpforTwoFactor(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/2fa/verify", ///api/auth/2fa/verify
      formData,
      this.config
    );
    return data.data;
  }

  async logout(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId || "");

    const data = await axios.post(
      Config.BACKEND_URL + "/api/auth/logout",
      {},
      this.config
    );
    return data.data;
  }
}

export default new RestService();
